﻿// Extract baseUrl from Drupal?

let baseUrl = "~";
let initialized = false;

export function getBaseUrl() {
  if (initialized) {
    return baseUrl;
  }
  let input = document.getElementsByName("baseUrl");
  if (input.length > 0) {
    console.log("baseurl extracted from baseUrlInput (Drupal) " + baseUrl);
    baseUrl = (input[0] as any).value;
  }

  if (baseUrl === "~") {
    const hostUrl = window.location.href.split("/");
    baseUrl = hostUrl[0] + "//" + hostUrl[2];
    console.log("baseurl converted to  " + baseUrl);
  }
  initialized = true;
  return baseUrl; 
}
